<template>
  <div id="app">
    <title>Recad Censo</title>
    <template v-if="online === true || offline_routes.includes(mainRoute)">
      <div v-if="meta_loaded === true">
        <template v-if="no_auth_routes.includes(mainRoute)">
          <header-app />
          <router-view />
          <cookies-accept-decline />
        </template>
        <template v-else>
          <login @userLogedIn="handleUserLogedIn" />
          <header-app v-if="userLogedIn === true" />
          <router-view v-if="(userLogedIn === true || online === false)" />
        </template>
      </div>
      <div v-else class="loading-wrapper home">
        <loading />
      </div>
    </template>
    <template v-else>
      <offline />
    </template>
  </div>
</template>

<script>
import {CONFIG} from '@/config/config.js'
import Login from '@/components/Login.vue'
import Loading from '@/components/Loading.vue'
import Header from '@/components/Header.vue'
import Offline from '@/components/Offline.vue'
import CookiesAcceptDecline from "@/components/CookiesAcceptDecline.vue"

export default {
  components: {
    'login': Login,
    'loading': Loading,
    'header-app': Header,
    'offline': Offline,
    "cookies-accept-decline": CookiesAcceptDecline,
  },
  name: 'App',
  data () {
    return {
      mainRoute: this.$route.name,
      online: navigator.onLine,
      loading: true,
      isHidden: true,
      meta_loaded: false,
      userLogedIn: false,
      no_auth_routes: [
        'About',
        'Privacy',
        'Info',
        'Tutorial',
        'Ajuda',
        'Contato',
        'Sobre',
        'Legal',
        'Termos',
        'TutorialCnis'
      ],
      offline_routes: [
        'About',
        'Privacy',
        'Info',
        'Ajuda',
        'Contato',
        'Sobre',
        'Legal',
        'Termos',
        'TutorialCnis'
      ],
    }
  },
  validations: {
  },
  methods: {
    handleUserLogedIn() {
      this.userLogedIn = true
    },
    togglePageScroll(){
      if(this.mainRoute === "About"){
        document.querySelector('body').classList.add('overflow-hidden')
      } else {
        document.querySelector('body').classList.remove('overflow-hidden')
      }
    },
    setup_domain() {
      var host = window.location.host;
      const meta_data = this.$store.state.meta.data;

      if (!(["recadastramento.com.br", "recad.com.br", "localhost:8080"].includes(host))) {
        this.$store.state.meta.data.host = host
        meta_data.censo_domain = meta_data.censo_domain_esp
        meta_data.censo_domain_banner = meta_data.censo_domain_esp[host]["banner"]
      }
    }
  },
  mounted () {
    this.togglePageScroll()
    this.$store.subscribe((mutation, state) => {
      if(mutation.type === 'updateMeta') {
        this.meta_loaded = true
        this.setup_domain()
      }
    })
  },
  watch: {
    '$route' (to, from) {
      if(['Contato'].includes(from.name)){
        const bot_id = document.querySelector("#boteria_webchat")
        if(bot_id){
          bot_id.remove()
        }
      }
      this.mainRoute = this.$route.name
      this.online = navigator.onLine
      this.togglePageScroll()
    }
  },
}
</script>

<style>

jdiv:nth(2) {
  display: none;
}
input {
  background-color: white !important;
  text-transform: uppercase;
}

ul.collapsible li div,  ul.collapsible {
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue